export default __webpack_public_path__ + "static/desk-property002-5b3fdc3af8648750414090c9c39e9c6a.png";